<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="d-flex align-items-center ps-5 pb-3 pt-1">
            <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
            <app-status [statuses]="tokenStatuses" class="pe-2" (close)="onStatusOption($event)"></app-status>
            <app-status [statuses]="tokenTypes" [title]="'TOKEN_TYPE'" class="pe-2" (close)="onTypeOption($event)"></app-status>
            <div class="datepicker-container-wrapper position-relative">
                <div class="button-wrapper">
                    <div class="button">
                        <img alt="Date" src="assets/core/table-button/date.svg" />
                        <div class="button-text" (click)="toggleDatepicker()" [ngClass]="{ changed: startDate && endDate }">
                            <ng-container *ngIf="startDate && endDate; else noDateSelected">
                                {{ selectedDate }}
                            </ng-container>
                            <ng-template #noDateSelected>
                                <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                            </ng-template>
                        </div>
                        <img *ngIf="startDate && endDate" alt="Exit" src="assets/device/x.svg" (click)="clearDates()" />
                    </div>
                </div>
                @if (isDatepickerOpen) {
                <div class="overlay" (click)="toggleDatepicker()"></div>
                <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
                    [inputFromDate]="startDate" [inputToDate]="endDate"></app-datepicker>
                }
            </div>
            <app-search placeholder="{{ 'TOKEN_SEARCHBY' | translate }}" (searchChange)="searchChange($event)"></app-search>
        </div>
        <div class="row g-0 m-0">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th><span>{{ "TOKEN_ID" | translate }}</span></th>
                        <th><span>{{ "TOKEN_TYPE" | translate }}</span></th>
                        <th><span>{{ "COMMAND_SOURCE" | translate }}</span></th>
                        <th><span>{{ "TIMESTAMP" | translate }}</span></th>
                        <th><span>{{ "TOKEN_AMOUNT" | translate }}</span></th>
                        <th><span>{{ "TOKEN_STATUS" | translate }}</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of tokens; let i = index">
                        <td appIsNew [executedTime]="row.startTime!"></td>
                        <td>
                            <span class="copyable" (click)="clipboardService.copyToClipboard(row.token!, $event, i)">
                                {{ row.token }}
                                <span class="copy-tooltip" *ngIf="clipboardService.copiedText === i.toString()">{{ "COPIED" | translate }}</span>
                            </span>
                        </td>
                        <td><span>{{ row.type }}</span></td>
                        <td><span>{{ row.source }}</span></td>
                        <td><span>{{ row.startTime ? (row.startTime | date: 'dd MMM yyyy, h:mm a') : '/' }}</span></td>
                        <td><span>{{ row.tokenAmount ?? '/' }}</span></td>
                        <td (click)="printResponseOfCommand($event, row)">
                            <div class="status-container">
                                <span [ngClass]="{
                                    'status-pending': row.tokenStatus === 'Pending',
                                    'status-completed': row.tokenStatus === 'Success',
                                    'status-failed': row.tokenStatus === 'Failed'
                                }">{{ row.tokenStatus }}</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="container-down">
        <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfTokens" [pageSize]="pageSize"
            [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
    </div>
</div>
